import { Editable, EditableInput, EditablePreview } from "@chakra-ui/editable";
import { Flex, TextProps } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Mspr from "../utils/Mspr";
import { Bank, Preset } from "../utils/types";

interface Props extends TextProps {
    entity: Bank | Preset;
    index: number;
    hideIndices: boolean;
    handleRename: (entity: Bank | Preset, newName: string) => void;
}

export const Title = ({ entity, index, hideIndices, handleRename, ...textProps }: Props) => {
    const { t } = useTranslation();
    const isBank = entity.hasOwnProperty('presets');
    const prefix = isBank ? 'B' : 'P';
    const numPresets = isBank ? Mspr.getPresetCount(entity as Bank) : undefined;
    return (
        <Flex
            {...textProps}
            whiteSpace='nowrap'
            textTransform='uppercase'
            alignItems='center'
        >
            <span>
                [{prefix}
                <span style={{
                    visibility: hideIndices ? 'hidden' : 'visible',
                    // animate opacity to avoid flickering
                    opacity: hideIndices ? 0 : 1,
                    transition: 'opacity 0.2s ease-in-out',
                    willChange: 'opacity',
                    // 
                }}>
                    {/* B0-B127, P1-P128 */}
                    {isBank ? index : index + 1}
                </span>
                ]
            </span>
            <Editable
                display='inline-flex'
                marginLeft='0.25rem'
                defaultValue={entity.name}
                placeholder={isBank && numPresets ? t('untitledPlaceholder')! : t('emptyPlaceholder')!}
                width='100%'
                borderBottom='1px solid rgba(0,0,0,0.2)'
                boxSizing='border-box'
            >
                <EditablePreview
                    cursor='text'
                    overflow='hidden'
                    textOverflow='ellipsis'
                    maxWidth='20eqm'
                    width='100%'
                />
                <EditableInput
                    display='inline-flex'
                    onBlur={(e) => handleRename(entity, e.target.value)}
                    maxLength={Mspr.MAX_NAME_LENGTH}
                    width='100%'
                    onBlurCapture={(e) => handleRename(entity, e.target.value)}
                    textTransform='uppercase'
                    onKeyDown={(e) => {
                        // filename unfriendly chars
                        const badChars = ['\\', '/', ':', '*', '?', '"', '<', '>', '|'];
                        const isNonAscii = e.key.length === 1 && e.key.charCodeAt(0) > 127;
                        const isPaste = (e.ctrlKey || e.metaKey) && e.key === 'v';
                        if (isNonAscii || isPaste || badChars.includes(e.key)) {
                            e.preventDefault();
                        }
                    }}
                />
            </Editable>
            {numPresets !== undefined && <Text style={{ marginLeft: 'auto' }}>({numPresets}/{Mspr.MAX_SLOTS})</Text>}
        </Flex>
    );
}